import $ from 'jquery';
import jQuery from 'jquery';
window.$ = jQuery;
import AOS from 'aos';
import 'bootstrap';
import 'jquery-parallax.js';
import Blazy from 'blazy';
import owlCarousel from 'owl.carousel';

(function($) {

var $event = $.event,
	$special,
	resizeTimeout;

$special = $event.special.debouncedresize = {
	setup: function() {
		$( this ).on( "resize", $special.handler );
	},
	teardown: function() {
		$( this ).off( "resize", $special.handler );
	},
	handler: function( event, execAsap ) {
		// Save the context
		var context = this,
			args = arguments,
			dispatch = function() {
				// set correct event type
				event.type = "debouncedresize";
				$event.dispatch.apply( context, args );
			};

		if ( resizeTimeout ) {
			clearTimeout( resizeTimeout );
		}

		execAsap ?
			dispatch() :
			resizeTimeout = setTimeout( dispatch, $special.threshold );
	},
	threshold: 150
};

})(jQuery);

$(window).trigger('resize').trigger('scroll');

$(document).ready(function() {
  AOS.init({
    once: true
  });

  var bLazy = new Blazy();
});

// Blog posts owl
function owlInitialize() {
  if ($(window).width() < 768) {
      $('.related-offices').addClass("owl-carousel").removeClass("row");
      $('.related-offices.owl-carousel').owlCarousel({
          loop: true,
          margin: 15,
          nav: false,
          dots: true,
          responsive:{
              0:{
                  items:1,
              },
							576:{
                  items:2
              }
          }
      });
  }else{
      $('.related-offices.owl-carousel').owlCarousel('destroy');
      $('.related-offices').removeClass("owl-carousel").addClass("row");
  }

  if ($(window).width() < 576) {
      $('.tabs-mobile').addClass("owl-carousel").removeClass("row");
      $('.tabs-mobile.owl-carousel').owlCarousel({
          loop: true,
          margin: 15,
          nav: false,
          dots: true,
          responsive:{
              0:{
                  items:1,
              }
          }
      });
  }else{
      $('.tabs-mobile.owl-carousel').owlCarousel('destroy');
      $('.tabs-mobile').removeClass("owl-carousel").addClass("row");
  }

  if ($(window).width() < 1050) {
      $('.virtual-blocks').addClass("owl-carousel").removeClass("row");
      $('.virtual-blocks.owl-carousel').owlCarousel({
          loop: true,
          margin: 0,
          nav: false,
          dots: true,
					autoplay: true,
					responsive:{
              0:{
                  items:1,
              },
              540:{
                  items:1
              },
							768: {
								items:2
							}
          }
      });
  }else{
      $('.virtual-blocks.owl-carousel').owlCarousel('destroy');
      $('.virtual-blocks').removeClass("owl-carousel").addClass("row");
  }

  if ($(window).width() < 576) {
      $('.clients-logos').addClass("owl-carousel");
      $('.clients-logos.owl-carousel').owlCarousel({
          loop: true,
          margin: 15,
          nav: false,
          autoplay: true,
          dots: false,
          responsive:{
              0:{
                  items:2,
              }
          }
      });
  }else{
      $('.clients-logos.owl-carousel').owlCarousel('destroy');
      $('.clients-logos').removeClass("owl-carousel");
  }

  if ($(window).width() < 1050) {
      $('.boxes-wrap').addClass("owl-carousel");
      $('.boxes-wrap.owl-carousel').owlCarousel({
          loop: true,
          margin: 15,
          nav: false,
          dots: false,
					autoplay: true,
          responsive:{
              0:{
                  items:1,
              },
              540:{
                  items:2
              },
							768: {
								items:3
							}
          }
      });
  }else{
      $('.boxes-wrap.owl-carousel').owlCarousel('destroy');
      $('.boxes-wrap').removeClass("owl-carousel");
  }

  if ($(window).width() < 1230) {
      $('.partners-carousel').addClass("owl-carousel");
      $('.partners-carousel.owl-carousel').owlCarousel({
          autoplay: true,
          loop: true,
          margin: 15,
          nav: false,
          dots: false,
          // center: true,
          responsive:{
              0:{
                  items:2,
              },
              575:{
                  items:3,
              },
              767:{
                  items:5,
              },
              900:{
                  items:6,
              }
          }
      });
  }else{
      $('.partners-carousel.owl-carousel').owlCarousel('destroy');
      $('.partners-carousel').removeClass("owl-carousel");
  }
}

import baguetteBox from "baguettebox.js";
function lightbox_image() {
  baguetteBox.run(".gallery", {
    animation: "fadeIn"
  });
}

$(window).on("debouncedresize", function(event) {
    setTimeout(function() {
      $(window).trigger('resize.px.parallax');
    }, 375);
  });

$(document).ready(function(e) {
  owlInitialize();
});

$(window).resize(function() {
  owlInitialize();
});


var testimonialsCarousel = function() {
  $('.testimonials-carousel').owlCarousel({
      autoplay: true,
      loop: true,
      margin: 0,
      nav: false,
      dots: false,
      items: 1,
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      mouseDrag: false
  });
}

var contactCarousel = function() {
  $('.contact-slider').owlCarousel({
      autoplay: true,
      loop: true,
      margin: 40,
      nav: false,
      center: true,
      responsive:{
          0:{
              items:1,
          },
          575:{
              items:2,
          },
          767:{
              items:3,
          },
          900:{
              items:4,
          }
      }
  });
}

// Scroll to
$(function () {
	$("a.goto").on('click', function (event) {
		event.preventDefault();
		if (this.hash !== "") {
			var hash = this.hash;
			$('html, body').animate({
				scrollTop: ($(hash).offset().top) - 90
			}, 800);
		}
	});

  $(".page-template-home-template .menu-item-type-custom a").on('click', function (event) {
		event.preventDefault();
		if (this.hash !== "") {
			var hash = this.hash;
			$('html, body').animate({
				scrollTop: ($(hash).offset().top) - 90
			}, 800);
		}
	});

  $('.collapse').on('shown.bs.collapse', function () {
        $(this).parent().addClass('active');
    });

    $('.collapse').on('hidden.bs.collapse', function () {
        $(this).parent().removeClass('active');
    });

  testimonialsCarousel();
  contactCarousel();
	lightbox_image();

  // poster frame click event
$(document).on('click','.js-videoPoster',function(ev) {
  ev.preventDefault();
  var $poster = $(this);
  var $wrapper = $poster.closest('.js-videoWrapper');
  videoPlay($wrapper);
  $(this).parent().parent().find('.external-button').fadeOut();
});

$(document).on('click','.external-button',function(ev) {
  ev.preventDefault();
  var $poster = $(this).parent().find('.js-videoPoster');
  var $wrapper = $poster.closest('.js-videoWrapper');
  videoPlay($wrapper);
  $(this).fadeOut();
});

// play the targeted video (and hide the poster frame)
function videoPlay($wrapper) {
  var $iframe = $wrapper.find('.js-videoIframe');
  var src = $iframe.data('src');
  // hide poster
  $wrapper.addClass('videoWrapperActive');
  // add iframe src in, starting the video
  $iframe.attr('src',src);
}

// stop the targeted/all videos (and re-instate the poster frames)
function videoStop($wrapper) {
  // if we're stopping all videos on page
  if (!$wrapper) {
    var $wrapper = $('.js-videoWrapper');
    var $iframe = $('.js-videoIframe');
  // if we're stopping a particular video
  } else {
    var $iframe = $wrapper.find('.js-videoIframe');
  }
  // reveal poster
  $wrapper.removeClass('videoWrapperActive');
  // remove youtube link, stopping the video from playing in the background
  $iframe.attr('src','');
}
});
